import { useEffect, useState } from 'react'
import { Dropdown, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CustomToggle from '../../../components/dropdowns'
import "react-responsive-carousel/lib/styles/carousel.min.css"
//image
import user01 from '../../../assets/images/user/01.jpg'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom'
import * as moment from 'moment'
import { getToken } from '../../../utils/auth'
import Card from '../../../components/Card'
import CarouselN from 'react-bootstrap/Carousel';
import ShareOffcanvas from '../../../components/share-offcanvas'
import { useTranslation } from 'react-i18next'
import { AiOutlineSend } from "react-icons/ai";


const SaveLostPostCardBody = ({ data, index, handleAllLostPost }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const { t, i18n } = useTranslation();

    const [content, setContent] = useState(null);
    const [comments, setComments] = useState(null);
    const [show, setShow] = useState(null);
    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');
    const [expandedRows, setExpandedRows] = useState({});
    const [like, setLike] = useState(false);
    const [likeCounts, setLikeCounts] = useState(0);

    const toggleExpand = (index) => {
        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [index]: !prevExpandedRows[index],
        }));
    };

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };
    const renderDescription = (data, index) => {
        const description = data?.itemDescription;
        const threshold = 180;

        if (description && description.length > threshold) {
            if (expandedRows[index]) {
                return (
                    <div>
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                        <button onClick={() => toggleExpand(index)} style={{ color: "#FF5500", background: "none", border: "none", cursor: "pointer", display: "block" }}>Show Less...</button>
                    </div>
                );
            } else {
                return (
                    <div>
                        <div style={{ display: "inline" }} dangerouslySetInnerHTML={{ __html: `${description.slice(0, threshold)}...` }} />
                        <button onClick={() => toggleExpand(index)} style={{ color: "#FF5500", background: "none", border: "none", cursor: "pointer", display: "inline" }}>Show More...</button>
                    </div>
                );
            }
        } else {
            return <div dangerouslySetInnerHTML={{ __html: description }} />;
        }
    };

    useEffect(() => {
        handleGetComments();
    }, [])
    const handleGetComments = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/device/comment/${data?._id}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setComments(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Devices", error);
        }
    }
    const handleChange = (e, index) => {
        setContent(e.target.value)
    }
    const [loadingComment, setLoadingComment] = useState(false);

    const handleAddComments = async (e, id) => {
        e.preventDefault();
        setLoadingComment(true); 

        try {

            const dataToSent = {
                "content": content,
                "attachmentLink": ''
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/device/comment/${id}`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            // toast.success(response?.data?.message);
            setContent('');
            handleGetComments(id);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoadingComment(false);
        }
    }
   
    const handleSavePost = async (postID) => {
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/post/save/${postID}`, {}, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            toast.success(response.data.message)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed Saving Post");
        }
    }

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Card.Body>
                <div className="user-post-data">
                    <div className="d-flex justify-content-between">
                        <div className="me-3">
                            <img className="rounded-circle img-fluid" src={data?.userId?.profileImageLink ? data?.userId?.profileImageLink : "/profile.png"} alt="" style={{ width: "55px", height: "50px" }} />
                        </div>
                        <div className="w-100">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h5 className="mb-0 d-inline-block">{data?.userId?.firstName} {data?.userId?.lastName}</h5>
                                    {/* <span className="mb-0 ps-1 d-inline-block">Add New Post</span> */}
                                    {/* <p className="mb-0 text-primary">Just Now</p> */}
                                </div>
                                <div className="card-post-toolbar" style={{ display: "flex" }}>
                                    {data?.userId?.qrCodeUrl ? (<div>
                                        <img src={data?.userId?.qrCodeUrl}
                                            onClick={() => handleQrClick(data?.userId?.qrCodeUrl)}
                                            style={{
                                                width: "50px",
                                                height: "50px",

                                            }} />
                                    </div>) : (
                                        <div>


                                        </div>
                                    )}
                                    <Dropdown>
                                        <Dropdown.Toggle variant="bg-transparent">
                                            <span className="material-symbols-outlined">
                                                more_horiz
                                            </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-menu m-0 p-0">
                                            {/* <Dropdown.Item className=" p-3" to="#" onClick={() => handleSavePost(data._id)}>
                                                <div className="d-flex align-items-top">
                                                    <div className="h4 material-symbols-outlined">
                                                        <i className="ri-save-line"></i>
                                                    </div>
                                                    <div className="data ms-2">
                                                        <h6>{t('save_post')}</h6>
                                                        <p className="mb-0">{t('add_to_saved_items')}</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item> */}
                                            <Dropdown.Item className="p-3" to="#">
                                                <div className="d-flex align-items-top">
                                                    <i className="ri-close-circle-line h4"></i>
                                                    <div className="data ms-2">
                                                        <h6>{t('hidePost')}</h6>
                                                        <p className="mb-0">{t('seeFewerPosts')}</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                            <Dropdown.Item className=" p-3" to="#">
                                                <div className="d-flex align-items-top">
                                                    <i className="ri-user-unfollow-line h4"></i>
                                                    <div className="data ms-2">
                                                        <h6>{t('unfollowUser')}</h6>
                                                        <p className="mb-0">{t('stopSeeingPosts')}</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                            <Dropdown.Item className=" p-3" to="#">
                                                <div className="d-flex align-items-top">
                                                    <i className="ri-notification-line h4"></i>
                                                    <div className="data ms-2">
                                                        <h6>{t('notifications_label')}</h6>
                                                        <p className="mb-0">{t('notifications')}</p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3">
                    <p>{renderDescription(data, index)}</p>
                    {/* <p>{data?.description}</p> */}
                </div>
                <div className="user-post">
                    {/* <div className=" d-grid grid-rows-2 grid-flow-col gap-3">
                                                <div className="row-span-2 row-span-md-1">
                                                    <img src={p2} alt="post1" className="img-fluid rounded w-100"/>
                                                </div>
                                                <div className="row-span-1">
                                                    <img src={p1} alt="post2" className="img-fluid rounded w-100"/>
                                                </div>
                                                <div className="row-span-1 ">
                                                    <img src={p3} alt="post3" className="img-fluid rounded w-100"/>
                                                </div>
                                            </div> */}
                    {/* {data?.photos?.map((image) => ( */}
                    <div className="user-post">
                        <CarouselN style={{ maxWidth: '600px', margin: '0 auto' }}>
                            {data?.devicePhotos?.map((photo, photoIndex) => (
                                <CarouselN.Item key={photoIndex}>
                                    <img
                                        className="d-block w-100"
                                        src={photo}
                                        alt={`post-photo-${photoIndex}`}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                        }}
                                    />
                                </CarouselN.Item>
                            ))}
                        </CarouselN>
                    </div>                                            {/* ))} */}
                </div>
                <div className="comment-area mt-3">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div className="like-block position-relative d-flex align-items-center">
                            {/* <div className="d-flex align-items-center">
                                <div className="like-data">
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle} >
                                            <img src={icon1} className="img-fluid" alt="" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className=" py-2" onClick={(e) => { handleAddLikes(e, data?._id, true); setLike(!like) }}>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Like</Tooltip>} className="ms-2 me-2" >{like ? <AiFillLike color="blue" className="img-fluid me-2 " size="25" /> : <AiOutlineLike color="blue" className="img-fluid me-2 " size="25" />}</OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Love</Tooltip>} className="me-2" ><img src={icon2} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Happy</Tooltip>} className="me-2" ><img src={icon3} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>HaHa</Tooltip>} className="me-2" ><img src={icon4} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Think</Tooltip>} className="me-2" ><img src={icon5} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Sade</Tooltip>} className="me-2" ><img src={icon6} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Lovely</Tooltip>} className="me-2" ><img src={icon7} className="img-fluid me-2" alt="" /></OverlayTrigger>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="total-like-block ms-2 me-3">
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                            {likeCounts} {data?.likes?.length > 1 ? 'Likes' : 'Like'}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                            <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                            <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                            <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                            <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                            <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                            <Dropdown.Item href="#">Other</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div> */}
                            <div className="total-comment-block">
                                <Dropdown>
                                    <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                        {comments?.allComments.length} {t('comments')}
                                    </Dropdown.Toggle>
                                    {/* <Dropdown.Menu>
                                        <Dropdown.Item href="#">Max Emum</Dropdown.Item>
                                        <Dropdown.Item href="#">Bill Yerds</Dropdown.Item>
                                        <Dropdown.Item href="#">Hap E. Birthday</Dropdown.Item>
                                        <Dropdown.Item href="#">Tara Misu</Dropdown.Item>
                                        <Dropdown.Item href="#">Midge Itz</Dropdown.Item>
                                        <Dropdown.Item href="#">Sal Vidge</Dropdown.Item>
                                        <Dropdown.Item href="#">Other</Dropdown.Item>
                                    </Dropdown.Menu> */}
                                </Dropdown>
                            </div>
                        </div>
                        <ShareOffcanvas />
                    </div>
                    <hr />
                    <ul className="post-comments p-0 m-0">
                        {
                            comments?.allComments?.slice(0, 3).map((i) =>
                                <li className="mb-2">
                                    <div className="d-flex">
                                        <div className="user-img">
                                            <img src={i?.author?.profileImageLink ? i?.author?.profileImageLink : "/profile.png"} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                        </div>
                                        <div className="comment-data-block ms-3">
                                            <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                            <p className="mb-0">{i?.content}</p>
                                            <div className="d-flex flex-wrap align-items-center comment-activity">

                                                <span> {moment(i?.timestamp).fromNow()} </span>
                                            </div>
                                        </div>
                                    </div>

                                </li>
                            )
                        }
                        {
                            show === index &&
                            comments?.allComments?.slice(3, 10000000000).map((i) =>
                                <li className="mb-2">
                                    <div className="d-flex">
                                        <div className="user-img">
                                            <img src={i?.author?.profileImageLink ? i?.author?.profileImageLink : "/profile.png"} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                        </div>
                                        <div className="comment-data-block ms-3">
                                            <h6>{i?.author?.firstName} {i?.author?.lastName}</h6>
                                            <p className="mb-0">{i?.content}</p>
                                            <div className="d-flex flex-wrap align-items-center comment-activity">
                                                {/* <Link to="">like</Link>
                                                <Link to="">reply</Link>
                                                <Link to="">translate</Link> */}
                                                <span> {moment(i?.timestamp).fromNow()} </span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )

                        }
                        <button className='bg-white border-0 ' onClick={() => { setShow(show === index ? null : index) }}>{comments?.allComments?.length > 3 && (show === index ? 'Show Less' : 'Show More')}</button>
                    </ul>
                    <form className="comment-text d-flex align-items-center mt-3" onSubmit={(e) => handleAddComments(e, data?._id)} style={{ position: "relative" }}>
    <input
        type="text"
        className="form-control rounded"
        placeholder={t('enterYourComment')}
        value={content}
        onChange={(e) => handleChange(e)}
        style={{ paddingRight: "40px" }}
        disabled={loadingComment}
    />
    <button type="submit" style={{ position: "absolute", right: "10px", background: "none", border: "none", cursor: loadingComment ? "not-allowed" : "pointer" }} disabled={loadingComment}>
        <AiOutlineSend size={24} color={loadingComment ? "gray" : "#007bff"} />
    </button>
</form>
                </div>
            </Card.Body>
            <Modal size="md" className="fade" id="qr-modal" onHide={closeQrPopup} show={qrPopupOpen} centered >
                <Modal.Header closeButton>
                    <Modal.Title>{t('qr_code')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={qrImageUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeQrPopup}>Close</button>
                </Modal.Footer>

            </Modal>
        </>
    )
}

export default SaveLostPostCardBody
